export default Object.freeze({
  SALESFORCE_INTEGRATION_STATUS: 'SALESFORCE_INTEGRATION_STATUS'
});